import type { User } from 'firebase/auth'

export const getUserAuthHeaders = async (user: User) => {
  const token = await user.getIdToken()
  return { Authorization: `Bearer ${token}` } as const
}

/**
 * Where a request's bearer token comes from. `app-token` exists for the in-app
 * cross-sell: the page runs in the mobile app's WebView with no Firebase
 * session of its own, so it forwards the ID token the app injected. The web
 * SDK cannot sign in with an ID token, which is why this is a separate source
 * rather than a synthesised `User`.
 */
export type AuthSource = { kind: 'firebase'; user: User } | { kind: 'app-token'; token: string }

export const getAuthHeaders = async (source: AuthSource) => {
  switch (source.kind) {
    case 'firebase':
      return getUserAuthHeaders(source.user)
    case 'app-token':
      return { Authorization: `Bearer ${source.token}` } as const
  }
}

/** Wraps a signed-in user for the calls that take an {@link AuthSource}. */
export const firebaseAuthSource = (user: User): AuthSource => ({ kind: 'firebase', user })
